import * as React from "react";
import TextField from "../../../metamodel/Fields/TextField";
import {ControlLabel, FormControl, FormGroup} from "react-bootstrap";

interface TextFilterFieldProps {
    field: TextField,
    value: string,
    onChange?: (value: string) => void
}

export default class TextFilterField extends React.Component<TextFilterFieldProps> {
    constructor(props: TextFilterFieldProps) {
        super(props);
    }


    public render(): React.ReactNode {
        const onChange = (e: any) => this.props.onChange && this.props.onChange(e.target.value);
        return <FormGroup controlId={this.props.field.id}>
            <ControlLabel>{this.props.field.name}</ControlLabel>
            <FormControl type="text" value={this.props.value || ""} onChange={onChange} />
        </FormGroup>
    }
}


// WEBPACK FOOTER //
// ./src/homepage/components/filters/TextFilterField.tsx